<template>
  <div>
    <cancel-button
      type="button"
      @click="$emit('cancel')"
    >
      {{ $t(`${boletoCancelStep}.cancel`) }}
    </cancel-button>

    <confirm-button
      type="submit"
      class="eu-ml_1"
      :disabled="disabled"
      @click="handleClick"
    >
      {{ $t(`${boletoCancelStep}.confirm`) }}
    </confirm-button>
  </div>
</template>
<script>
import CancelButton from '@/components/project/molecules/CancelButton.vue'
import ConfirmButton from '@/components/project/molecules/ConfirmButton.vue'
import PropsValidator from '@/utils/validator'
import { chargesEvents as Amplitude } from '@/amplitude-events/sales.amplitude'

import { BOLETO_CANCEL_STEPS_ENUM } from '../enums/steps.enum'

export default {
  name: 'CancelOkActionButtonsSteps',
  components: {
    CancelButton,
    ConfirmButton
  },
  props: {
    boletoCancelStep: {
      type: String,
      validation: boletoCancelStep =>
        PropsValidator.validate(
          Object.keys(BOLETO_CANCEL_STEPS_ENUM),
          boletoCancelStep
        )
    },
    disabled: { type: Boolean, default: () => false }
  },
  methods: {
    handleClick () {
      Amplitude.events.actions.refoundBoletoClicked()
      this.$emit('confirm')
    }
  }
}
</script>
<i18n>
{
  "pt-BR": {
    "refund_type_step.confirm": "Continuar",
    "refund_type_step.cancel": "Sair",
    "bank_details_step.confirm": "Continuar",
    "bank_details_step.cancel": "Voltar",
    "confirm_bank_details_step.confirm": "Solicitar estorno",
    "confirm_bank_details_step.cancel": "Voltar"
  },
  "en-US": {
    "refund_type_step.confirm": "Next",
    "refund_type_step.cancel": "Exit",
    "bank_details_step.confirm": "Next",
    "bank_details_step.cancel": "Go back",
    "confirm_bank_details_step.confirm": "Request refund",
    "confirm_bank_details_step.cancel": "Go back"
  }
}
</i18n>
